// frontend/src/services/authService.js
import api from './api';

const authService = {
  // Login
  login: async (credentials) => {
    const response = await api.post('/auth/login/', credentials);
    if (response.data.user) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Logout
  logout: async () => {
    try {
      await api.post('/auth/logout/');
    } catch (error) {
      console.error('Error al hacer logout:', error);
    } finally {
      localStorage.removeItem('user');
    }
  },

  // Obtener usuario actual
  getCurrentUser: async () => {
    try {
      const response = await api.get('/auth/user/');
      if (response.data.authenticated) {
        // Guardar toda la data del usuario incluyendo cuenta_activa
        const userData = {
          ...response.data.user,
          cuenta_activa: response.data.cuenta_activa,
          has_cuenta: response.data.has_cuenta,
          requires_onboarding: response.data.requires_onboarding,
        };
        localStorage.setItem('user', JSON.stringify(userData));
        return userData;
      } else {
        localStorage.removeItem('user');
        return null;
      }
    } catch (error) {
      console.error('Error al obtener usuario:', error);
      localStorage.removeItem('user');
      return null;
    }
  },

  // Obtener CSRF token
  getCSRFToken: async () => {
    await api.get('/auth/csrf/');
  },

  // Verificar si está autenticado (desde localStorage)
  isAuthenticated: () => {
    const user = localStorage.getItem('user');
    return user !== null;
  },

  // Obtener usuario desde localStorage
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  // Cambiar contraseña del usuario autenticado
  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    const response = await api.post('/auth/change-password/', {
      current_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    });
    return response.data;
  },
};

export default authService;
